import React, { useState, useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";
import TimeOutModal from "./TimeOutModal";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as acts from "../redux/auth/actions";
import auth from "../config/auth";

const IdealTimeoutHooks = () => {
  const timeout = 15 * 60 * 1000; // 15 minutes
  const promptBeforeIdle = 2 * 60 * 1000; // Warning 2 minutes before logout

  const [remaining, setRemaining] = useState(timeout);
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userLogout = useSelector(
    (state) => state?.auth?.userLogout
  );

  const handleOnActive = () => {
    setShowModal(false);
    setRemaining(timeout);
  };

  const handleOnPrompt = () => {
    setShowModal(true);
  };

  const handleOnIdle = () => {
    setShowModal(false);
    dispatch(acts.userLogout(true));
  };

  const { reset, getRemainingTime } = useIdleTimer({
    timeout,
    promptBeforeIdle,
    onActive: handleOnActive,
    onPrompt: handleOnPrompt,
    onIdle: handleOnIdle,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(getRemainingTime());
    }, 1000);

    return () => clearInterval(interval);
  }, [getRemainingTime]);

  useEffect(() => {
    if (userLogout?.apiSuccess) {
      localStorage.clear();
      auth.logout();
      navigate("/");
    }
  }, [userLogout, navigate]);

  const handleClose = () => {
    setShowModal(false);
    reset();
    setRemaining(timeout);
  };

  const handleLogout = () => {
    setShowModal(false);
    dispatch(acts.userLogout(true));
  };

  return (
    <div>
      {showModal && (
        <TimeOutModal
          remaining={remaining}
          showModal={showModal}
          handleClose={handleClose}
          handleLogout={handleLogout}
        />
      )}
    </div>
  );
};

export default IdealTimeoutHooks;